import * as yup from "yup";

const createEditWaypointValidationSchema = yup.object({
  note: yup.string().optional(),
  place: yup
    .object({
      placeName: yup.string().min(1).required(),
      address: yup.string().optional(),
      city: yup.string().optional(),
      coord: yup.object({
        lon: yup.number().optional(),
        lat: yup.number().optional(),
      }),
      country: yup.string().optional(),
    })
    .required(),
  shouldShowToDriver: yup.boolean().required(),
});

export default createEditWaypointValidationSchema;